import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'geocoderCountryRestriction',
  initialState: null as string | null,
  reducers: {
    setGeocoderCountryRestriction(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setGeocoderCountryRestriction } = slice.actions;

export default slice.reducer;
